// extracted by mini-css-extract-plugin
export var avatar = "_pg-3";
export var avatarContainer = "_pg-2";
export var avatarSpacer = "_pg-5";
export var avatarSpacerContainer = "_pg-4";
export var avatarStackContainer = "_pg-1";
export var bubble = "_pg-0";
export var remainderBubble = "_pg-6";